import axios from "axios";
import { CommonHttp } from "@/models/interfaces/http/common.http.request";
import { ProjectContainer, ProjectInfoFull, StageBusinessLogic } from "@/models/interfaces/project/project-models";
import { CommonEntityRecord } from "@/models/interfaces/common";
import { CommonWorkerHolder } from "@/models/interfaces/workers/worker-models";
import { AttachClient } from "@/ api/ClientsApi";
import { ProjectContactsRequest } from "@/store/project-page";


export class ProjectApi {
    // Получение объекта с данными проекта на странице Проекта
    static GetProject(projectId: number): Promise<ProjectContainer> {
        const http = new CommonHttp();
        return http
            .get(`projects/${projectId}`)
            .then((data) => {
                if (axios.isAxiosError(data)) {
                    throw data;
                }
                return data.data;
            });
    }

    // Переименование проекта
    static renameProject(entityId: number, name: string): Promise<any> {
        const http = new CommonHttp()
        return http
            .patch(`projects/rename`, { name, entityId })
            .then(data => data.data)
    }

    // Удаление проекта
    static deleteProject(projectId: number): Promise<any> {
        const http = new CommonHttp()
        return http
            .delete(`projects?Id=${projectId}`)
            .then(data => data.data)
    }

    // Смена этапа проекта
    static changeStage(projectId: number, newStageId: number): Promise<any> {
        const http = new CommonHttp()
        return http
            .put(`projects/stage`, { projectId, newStageId })
            .then(data => data.data)
    }

    // Получение подробной информации о проекте (для модалки)
    static getProjectInfo(projectId: number): Promise<ProjectInfoFull> {
        const http = new CommonHttp()
        return http
            .get(`projects/info?Id=${projectId}`)
            .then(data => data.data)
    }

    // Получение бизнес-логики этапа (кто может переводить и соседние этапы)
    static getStageBusinessLogic(stageId: number): Promise<StageBusinessLogic> {
        const http = new CommonHttp()
        return http
            .get(`stage/bisness/${stageId}`)
            .then(data => data.data)
    }

    // Получение списка клиентов для присоединения к проекту
    static getAttachClientsList(Id: number, Filter: string, Skip: number, Take: number): Promise<AttachClient[]> {
        const http = new CommonHttp()
        return http
            .get(`projects/attach/list?Id=${Id}&Filter=${encodeURIComponent(Filter)}&Skip=${Skip}&Take=${Take}`)
            .then(data => data.data)
    }

    // Присоединение клиента к проекту
    static attachClient(projectId: number, clientId: number): Promise<any> {
        const http = new CommonHttp()
        return http
            .put(`projects/attach`, { entityIdToAttach: projectId, clientId })
            .then(data => data.data)
    }

    // Отсоединение клиента от проекта
    static detachClient(projectId: number, clientId: number): Promise<any> {
        const http = new CommonHttp()
        return http
            .put(`projects/detach`, { entityIdToAttach: projectId, clientId })
            .then(data => data.data)
    }

    // Получение списка сотрудников для присоединения к проекту
    static getAttachWorkersList(projectId: number): Promise<CommonWorkerHolder[]> {
        const http = new CommonHttp()
        return http
            .get(`workerinproject/workers/attach?Id=${projectId}`)
            .then(data => data.data)
    }

    // Присоединение сотрудника к проекту
    static attachWorker(entityId: number, workerId: number): Promise<any> {
        const http = new CommonHttp()
        return http
            .put(`workerinproject/attach`, { entityId, workerId })
            .then(data => data.data)
    }

    // Отсоединение сотрудника от проекта
    static detachWorker(entityId: number, workerId: number): Promise<any> {
        const http = new CommonHttp()
        return http
            .put(`workerinproject/detach`, { entityId, workerId })
            .then(data => data.data)
    }

    // Получение списка ролей, доступных для присоединения сотруднику в проекте
    static getWorkerRoles(entityId: number, workerId: number): Promise<CommonEntityRecord[]> {
        const http = new CommonHttp()
        return http
            .get(`workerinproject/roles?EntityId=${entityId}&WorkerId=${workerId}`)
            .then(data => data.data)
    }

    // Присоединение роли сотруднику в проекте
    static attachRole(workerId: number, entityId: number, roleId: number): Promise<void> {
        const http = new CommonHttp()
        return http
            .put(`workerinproject/role/attach`, { WorkerId: workerId, EntityId: entityId, RoleId: roleId })
            .then(() => undefined)
    }

    // Отсоединение роли у сотрудника в проекте
    static detachRole(workerId: number, entityId: number, roleId: number): Promise<void> {
        const http = new CommonHttp()
        return http
            .put(`workerinproject/role/dettach`, { WorkerId: workerId, EntityId: entityId, RoleId: roleId })
            .then(() => undefined)
    }

    static getClientRoles(entityId: number, clientId: number): Promise<CommonEntityRecord[]> {
        const http = new CommonHttp()
        return http
            .get(`client/role?ProjectId=${entityId}&ClientId=${clientId}`)
            .then(data => data.data)
    }

    static attachClientRole(clientId: number, entityId: number, roleId: number): Promise<void> {
        const http = new CommonHttp()
        return http
            .post(`client/role/attach`, { ClientId: clientId, ProjectId: entityId, RoleId: roleId })
            .then(() => undefined)
    }

    static detachClientRole(clientId: number, entityId: number, roleId: number): Promise<void> {
        const http = new CommonHttp()
        return http
            .delete(`client/role`, { ClientId: clientId, ProjectId: entityId, RoleId: roleId })
            .then(() => undefined)
    }

    // Получение списка контактов на странице Проекта
    static getContactsForProject(requestModel: ProjectContactsRequest): Promise<any> {
        const http = new CommonHttp()
        return http
            .post(`persons/search/project`, requestModel)
            .then(data => data.data)
    }

    // Создание нового проекта
    static createProject(clientId: number, groupId: number): Promise<number> {
        const http = new CommonHttp()
        return http
            .post(`projects`, { clientId, groupId })
            .then(data => data.data)
    }
}
